import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/app/store/authStore';
import { useToast } from 'ah-common-lib/src/toast/Toast';
import { VButton } from 'ah-common-lib/src/common/components';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import IntegrationsTestComponent from '@/app/components/integrations/IntegrationsTestComponent.vue';
import { useFeatureFlagStore } from 'ah-common-stores';
import { computed, reactive, ref } from 'vue';
import { FEFeatureFlags, feFeatureFlags } from 'config/baseConfig';
import { VCol } from 'ah-common-lib/src/common/components';
import FeatureFlagList from 'ah-common-stores/src/devTools/FeatureFlagList.vue';
import MonthSelectorInput from 'ah-common-lib/src/date/MonthSelectorInput.vue';
import { ValidatedForm } from 'ah-common-lib/src/form/components';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { makeFormModel } from 'ah-common-lib/src/form/helpers';
import { dateField, monthSelectorField } from 'ah-common-lib/src/form/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'DevSettingsView',
  setup(__props) {

const appVersion = window.VUE_APP_VERSION;

const commitHash = window.VUE_APP_COMMIT_HASH;

const authStore = useAuthStore();

const toast = useToast();

const requestManager = useRequestManager().manager;

const featureFlagStore = useFeatureFlagStore();

const mockDate = ref<Date>();

const dateForm = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'dateForm',
    title: 'Dates',
    fieldType: 'form',
    fields: [dateField('date', 'Normal Date'), monthSelectorField('month', 'Month Selection')],
  }),
  validation: null,
});

const featureFlagEdits = computed(() =>
  Object.keys(feFeatureFlags).map((key) => {
    return {
      key: key as keyof FEFeatureFlags,
      state: featureFlagStore.isFEFeatureFlagOn(key as keyof FEFeatureFlags),
      edited: featureFlagStore.feFeatureFlagOverrideArr.some((i) => i.key === (key as keyof FEFeatureFlags)),
    };
  })
);

function invalidateSession() {
  authStore.authToken = 'INVALID';
  toast.success('Session invalidated');
}

function invalidateRefreshToken() {
  authStore.refreshToken = 'INVALID';
  toast.success('Refresh token invalidated');
}

function refreshSession() {
  requestManager.sameOrNewPromise(
    'refreshSession',
    () =>
      authStore.refreshSession().then(() => {
        authStore.isLoggedIn ? toast.success('Session refreshed') : toast.error('Session in error, logged out user');
      }),
    authStore.authToken
  );
}

return { __sfc: true,appVersion, commitHash, authStore, toast, requestManager, featureFlagStore, mockDate, dateForm, featureFlagEdits, invalidateSession, invalidateRefreshToken, refreshSession, VButton, IntegrationsTestComponent, VCol, FeatureFlagList, MonthSelectorInput, ValidatedForm }
}

})